export default {"src":"/_next/static/media/visitDays.a7adf67d.svg","height":850,"width":850,"blurWidth":0,"blurHeight":0};